// Client V2 common imports
const configureCommonStore = require('client-v2/common/state/store')
const articleProfileMiddleware = require('client-v2/common/containers/article-profile/state/middleware')

function configureStore(options) {
  return configureCommonStore({
    middlewares: [
      articleProfileMiddleware()
    ],
    reducer: require('./reducer'),
    reviver: require('./record').reviver,
    ...options
  })
}

module.exports = configureStore
